export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5215.a3537d90.jpg";